import { render, staticRenderFns } from "./r-currency-panel.vue?vue&type=template&id=7e4ffab6"
import script from "./r-currency-panel.vue?vue&type=script&lang=js"
export * from "./r-currency-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4ffab6')) {
      api.createRecord('7e4ffab6', component.options)
    } else {
      api.reload('7e4ffab6', component.options)
    }
    module.hot.accept("./r-currency-panel.vue?vue&type=template&id=7e4ffab6", function () {
      api.rerender('7e4ffab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-panel.vue"
export default component.exports